import React from 'react'
import styled from '@emotion/styled'
import { lessThan } from '@mobi/component-library/Utils/media'
import { SilkImage } from '@core/Components/SilkImage/SilkImage'
import { getImageUrlWithSizes } from '@core/Components/SilkImage/utils'

interface Props {
  meetingId: string
  meetingDate: string
  raceNo: number
  isDogsSilk: boolean
  isTrots: boolean
  acceptorNumber: number
}

export const SearchSilkImage: React.FC<Props> = ({
  meetingId,
  meetingDate,
  raceNo,
  isDogsSilk,
  isTrots,
  acceptorNumber,
}) => {
  const imageUrlWithSizes = getImageUrlWithSizes({ meetingId, meetingDate, isTrots, raceNo })

  const xOffset = acceptorNumber - 1

  return (
    <SearchSilkContainer>
      <SilkImage
        url={imageUrlWithSizes.large.url}
        height={imageUrlWithSizes.large.size.height}
        width={imageUrlWithSizes.large.size.width}
        isDogsSilk={isDogsSilk}
        xOffset={xOffset}
      />
    </SearchSilkContainer>
  )
}

// ======
// Styles
// ======

const SearchSilkContainer = styled.span({
  width: '2.5rem',
  verticalAlign: 'middle',
  display: 'block',
  padding: '0 0.5rem 0 0',
  marginTop: '0.5rem',
  marginRight: '0.25rem',

  [lessThan('px350')]: { display: 'none' },
})
